<template>
    <div>
        <!--        <v-row class="px-3 my-1">
                    <v-col class="text-left" cols="12" md="8">
                        <div class="text-h5">
                            Categories
                        </div>
                        <div class="subtitle-1 text-left mb-4">
                            Control access by category, whitelists and blacklists, and more
                        </div>
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="d-flex justify-end">
                            <v-text-field
                                ref="ruleSearch"
                                append-icon="mdi-magnify"
                                v-model="ruleFilterValue"
                                label="Narrow down rules"
                                clearable
                                v-if="isShowSearch && hideMobileListingForMobileIfListingItemSelected()"
                                class="search-listing-autocomplete max-width-450"
                            ></v-text-field>

                            <v-btn-toggle class="pr-2 my-1 ml-3 ">
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiMagnify"></v-icon>
                                </v-btn>
                            </v-btn-toggle>

                        </div>

                    </v-col>
                </v-row>-->

        <v-row class="mb-1">

            <!------------------------------------------------
                Categories Tabs
            ------------------------------------------------->

            <!--<v-col md="6" style="display: none;">
                <v-tabs v-model="categoriesTab" :color="isDark ? 'white': ''" class="mx-2" height="40">
                    <v-tab>
                        <v-icon class="mr-2">{{ icons.mdiFilter }}</v-icon>
                        {{ $gettext('Filtering') }}
                    </v-tab>
                    <v-tab>
                        <v-icon class="mr-2">{{ icons.mdiFormatListBulletedTriangle }}</v-icon>
                        {{ $gettext('Exceptions') }}
                    </v-tab>
                    <v-tab>
                        <v-icon class="mr-2">{{ icons.mdiCogStop }}</v-icon>
                        {{ $gettext('Options') }}
                    </v-tab>
                </v-tabs>
            </v-col>-->

            <!------------------------------------------------
                Categories Search
            ------------------------------------------------->

            <!--            <v-col v-if="($vuetify.breakpoint.mdAndUp || ($vuetify.breakpoint.smAndDown && showToggleCategories))"
                   md="6"
                   style="display: none;">
                <v-autocomplete
                    v-if="categoriesTab === 0 && showToggleCategories && profiles && profiles.length > 0"
                    ref="categoriesAutocompleteRef"
                    v-model="categoriesAutocomplete"
                    :items="allCategoriesForCurrentSelectedProfile"
                    :label="$gettext('Change status of categories')"
                    :prepend-inner-icon="icons.mdiMagnify"
                    hide-details
                    item-text="name"
                    return-object
                    @change="toggleCategoryItemStatus(categoriesAutocomplete)"
                >
                    <template v-slot:item="{ item }">

                        <v-list-item-content>
                            <v-list-item-title class="d-flex" flat>

                                <v-badge
                                    :color="item.status === 1 ? (isDark ? 'success' : 'secondary')  : 'grey'"
                                    class="mx-2 cursor-pointer my-auto"
                                    dot
                                    inline
                                >
                                </v-badge>

                                <span
                                    :class="{ 'success&#45;&#45;text font-weight-bold': item.status === 1 && isDark, 'secondary&#45;&#45;text font-weight-bold': item.status === 1 && !isDark , 'grey&#45;&#45;text': item.status !== 1}"
                                    v-text="$gettext(item.name)"></span>

                                <v-icon v-if="item.status === 1" class="ml-auto" color="secondary"
                                        v-text="icons.mdiCheck"></v-icon>
                                <v-icon v-if="item.status === -1" class="text-right ml-auto" color="grey"
                                        v-text="icons.mdiLock"></v-icon>

                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ $gettext(item.group) }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
</v-autocomplete>
</v-col>-->
        </v-row>

        <!--        <v-row class="text-right" v-show="categoriesTab === 0">
                    <v-col cols="12" md="4" offset-md="8" xl="3" offset-xl="9" class="d-flex flex-grow-1 flex-shrink-1 justify-end py-2">

        &lt;!&ndash;                <v-icon class="my-2 mr-1" @click="showSearch()" v-if="!isShowSearch" v-text="icons.mdiMagnify" color="secondary"></v-icon>&ndash;&gt;

        &lt;!&ndash;                v-if="isShowSearch"&ndash;&gt;



                    </v-col>
                </v-row>-->

        <v-tabs-items v-model="categoriesTab">

            <v-tab-item :key="0">

                <v-row class="mt-2">

                    <!------------------------------------------------
                        Left Sidebar (configurations-based, shared with other tabs)
                    ------------------------------------------------->

                    <v-col :lg="currentSelectedConfiguration ? 3 : 12" :md="currentSelectedConfiguration ? 4 : 12"
                        :xl="currentSelectedConfiguration ? 2 : 12" class="border-right-divider" cols="12">

                        <v-text-field
                            v-if="hideMobileListingForMobileIfListingItemSelectedForConfigurations() && hasConfigurations"
                            v-model="configurationFilterValue" :label="$gettext('Search phones')"
                            append-icon="mdi-magnify" class="search-listing-autocomplete" clearable></v-text-field>

                        <v-list
                            v-if="currentViewConfigurationCount() > 0 && hideMobileListingForMobileIfListingItemSelectedForConfigurations()"
                            class="v-list-wrapper">

                            <v-list-item-group v-model="currentSelectedConfiguration">

                                <v-list-item v-for="configuration in configurations"
                                    v-show="configurationSelectedForMobile() && checkEachConfiguration(configuration.key)"
                                    :key="configuration.key"
                                    :class="{ 'v-list-item v-item--active v-list-item--active primary--text': currentSelectedConfiguration === configuration.key }"
                                    :value="configuration.key" class="px-0 cursor-pointer" ripple
                                    @click="selectConfiguration(configuration.key)">
                                    <v-list-item-content>
                                        <v-list-item-title class="text-left">
                                            <v-row>
                                                <v-col class="body-2" cols="12">
                                                    <span class="pl-2" v-text="configuration.key"></span>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="configuration.value.userInfo.mdmDeviceId"
                                            class="text-left pl-2 text-truncate caption grey--text font-weight-light">
                                            {{ configuration.value.userInfo.mdmDeviceId }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>

                        <v-row v-else-if="configurationFilterValue.length > 0" class="mx-1 mt-0 mb-3">
                            <v-col>
                                {{
                                    $gettextInterpolate($gettext('No matching phones found for your search: %{
                                configurationFilterValue }'), {configurationFilterValue: configurationFilterValue})
                                    }}
                            </v-col>
                        </v-row>

                        <v-row v-else class="mx-1 mt-0 mb-3">
                            <v-col>
                                {{ $gettext('No phones configured yet. Please add a phone device from the users tab.')
                                }}
                            </v-col>
                        </v-row>
                    </v-col>

                    <!------------------------------------------------
                        Right side
                    ------------------------------------------------->

                    <v-col class="mx-auto" cols="12" :md="currentSelectedConfiguration ? 8 : 12"
                        :lg="currentSelectedConfiguration ? 9 : 12" :xl="currentSelectedConfiguration ? 10 : 12">

                        <template v-if="currentSelectedProfileIndex > -1">
                            <div class="text-h5 text-left">
                                {{ $gettext('Profile for') + ' ' +
                                    getDeviceName(
                                        profiles[currentSelectedProfileIndex]?.mdmDeviceId,
                                        profiles[currentSelectedProfileIndex]?.profile_name
                                    )
                                }}
                            </div>

                            <v-list v-if="categoryGroups && categoryGroups.length > 0" class="mb-4">

                                <v-list-group v-for="(group, groupIndex) in categoryGroups"
                                    v-if="group.profile === profiles[currentSelectedProfileIndex].profile_name"
                                    :key="groupIndex" :value="true">

                                    <template v-slot:activator>
                                        <v-list-item-title class="text-left align-center d-flex">
                                            <v-badge :color="getGroupLevelColor(group.groupName)"
                                                :title="$gettext('Click to toggle status of all the group items')"
                                                class="mx-1 my-auto" dot inline
                                                @click.native.stop="markAll(group.groupName)">
                                            </v-badge>
                                            <span :class="{ 'white--text': isDark }">{{ $gettext(group.groupName)
                                                }}</span>
                                        </v-list-item-title>
                                    </template>

                                    <div v-for="profile in profiles" class="text-left ml-8 mb-2">

                                        <v-chip v-for="categoryItem in profile.categories"
                                            v-if="currentSelectedProfileIndex > -1 && profiles[currentSelectedProfileIndex].profile_name === profile.profile_name && categoryItem.group === group.groupName"
                                            :color="categoryItem.status === 1 ? 'secondary' : ''"
                                            :input-value="categoryItem.status === 1" :value="categoryItem.status"
                                            class="ma-2" filter outlined
                                            @click="toggleCategoryItemStatus(categoryItem)">
                                            <v-icon v-if="categoryItem.status === -1" :color="!isDark ? 'primary' : ''"
                                                class="pa-2" v-text="icons.mdiLock"></v-icon>
                                            {{ $gettext(categoryItem.name) }}
                                        </v-chip>
                                    </div>


                                    <v-row class="ma-3">
                                        <v-col cols="12">

                                            <!--                                                  :disabled="[1, '1'].includes(currentSelectedRule.master)"-->
                                            <v-switch v-model="profiles[currentSelectedProfileIndex].any_destination"
                                                :class="{ 'o-60': !profiles[currentSelectedProfileIndex].any_destination }"
                                                :false-value="0" :label="$gettext('All Domains')" :true-value="1"
                                                class="mt-0 pt-0 font-weight-bold transition-ease-in-out">
                                            </v-switch>

                                            <v-card flat v-if="profiles[currentSelectedProfileIndex].any_destination">
                                                <!--                                                        <v-card-text class="subtitle-1 text-center">-->

                                                <v-card-title class="mb-3 justify-center">
                                                    <h3 class="d-flex align-center">
                                                        <!--                                                                    <v-img src="img/verify.png" width="32" class="mr-3" />-->
                                                        <v-icon class="mr-3" color="primary" lighten-1 x-large
                                                            v-text="icons.mdiCheckDecagram"></v-icon>
                                                        {{ $gettext('Full Access') }}
                                                    </h3>
                                                </v-card-title>
                                                <v-card-subtitle class="mb-3">
                                                    {{
                                                        $gettext('The permission applies to the entire Internet.')
                                                    }}
                                                </v-card-subtitle>
                                                <!--                                                        </v-card-text>-->
                                            </v-card>

                                            <v-row v-else>
                                                <v-col>
                                                    <v-combobox
                                                        v-model="profiles[currentSelectedProfileIndex].next_allowed_domains"
                                                        :label="$gettext('Domains')" chips deletable-chips multiple
                                                        outlined />
                                                    <!--                                                <v-combobox-->
                                                    <!--                                                    v-model="profiles[currentSelectedProfileIndex].next_allowed_groups"-->
                                                    <!--                                                    :label="$gettext('Groups')"-->
                                                    <!--                                                    chips-->
                                                    <!--                                                    deletable-chips-->
                                                    <!--                                                    multiple-->
                                                    <!--                                                    outlined-->
                                                    <!--                                                />-->

                                                    <!--                                                    @change="sortCurrentSelectedRule()"-->
                                                    <!--                                                    @click:append-outer="openEditGroupsDialog"-->
                                                    <v-autocomplete ref="internetFilterTabGroupsRef"
                                                        v-model="profiles[currentSelectedProfileIndex].next_allowed_groups"
                                                        :items="allGroupsForAutocomplete" :label="$gettext('Groups')"
                                                        :item-text="item => item.parent ? `${item.parent}/${item.group}` : item.group"
                                                        :item-value="item => item.parent ? `${item.parent}/${item.group}` : item.group"
                                                        chips multiple outlined>
                                                        <!-- Custom display for selected groups (chips) -->
                                                        <template v-slot:selection="data">
                                                            <v-chip close @click:close="removeDestGroup(data.item)">
                                                                <!-- For groups in folders -->
                                                                <span v-if="data.item.parent">
                                                                    <v-icon small class="mr-1"
                                                                        v-text="icons.mdiFolder"></v-icon>
                                                                    {{ data.item.parent }}
                                                                    <v-icon small class="mx-1"
                                                                        v-text="icons.mdiSlashForward"></v-icon>
                                                                    <v-icon small class="mr-1"
                                                                        v-text="data.item.isFolder ? icons.mdiFolder : icons.mdiSelectGroup"></v-icon>
                                                                    {{ data.item.group }}
                                                                </span>
                                                                <!-- For top-level items -->
                                                                <span v-else>
                                                                    <v-icon small class="mr-1"
                                                                        v-text="data.item.isFolder ? icons.mdiFolder : icons.mdiSelectGroup"></v-icon>
                                                                    {{ data.item.group }}
                                                                </span>
                                                            </v-chip>
                                                        </template>

                                                        <!-- Custom display for dropdown items -->
                                                        <template v-slot:item="{ item }">
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    <!-- For groups in folders -->
                                                                    <span v-if="item.parent">
                                                                        <v-icon small class="mr-1"
                                                                            v-text="icons.mdiFolder"></v-icon>
                                                                        {{ item.parent }}
                                                                        <v-icon small class="mx-1"
                                                                            v-text="icons.mdiSlashForward"></v-icon>
                                                                        <v-icon small class="mr-1"
                                                                            v-text="item.isFolder ? icons.mdiFolder : icons.mdiSelectGroup"></v-icon>
                                                                        {{ item.group }}
                                                                    </span>
                                                                    <!-- For top-level items -->
                                                                    <span v-else>
                                                                        <v-icon small class="mr-1"
                                                                            v-text="item.isFolder ? icons.mdiFolder : icons.mdiSelectGroup"></v-icon>
                                                                        {{ item.group }}
                                                                    </span>
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-list-group>
                            </v-list>
                            <v-row v-else-if="!profiles || profiles.length === 0" class="mx-1 my-4">
                                <v-col>{{ $gettext('Please create a profile') }}</v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col>
                                    {{ $gettext('No data found') }}
                                </v-col>
                            </v-row>
                        </template>

                        <v-row v-else-if="currentSelectedConfiguration" class="mx-1 my-4">
                            <v-col>
                                {{ $gettext('No web filter profile found for this device.') }}
                            </v-col>
                        </v-row>
                    </v-col>


                </v-row>

                <!--<v-row class="text-right" v-if="groups && groups.length > 0">
                        <v-col>
                            <small>
                                Categories: {{ groups.length }}
                            </small>
                        </v-col>
                </v-row>-->

            </v-tab-item>
            <v-tab-item :key="1">

                <v-row class="ma-3">
                    <v-col class="text-left">
                        <div class="text-h6">{{ $gettext('Categorization Errors') }}</div>
                        <div class="subtitle-1">{{ $gettext('These sites should not be blocked') }}</div>
                    </v-col>
                </v-row>

                <v-row class="ma-3">
                    <v-col cols="12">
                        <v-combobox v-model="whitelist" :label="$gettext('Safelist')" chips deletable-chips multiple
                            outlined />
                        <!--<v-combobox
                            v-model="blacklist"
                            label="Blacklist"
                            multiple
                            chips
                            deletable-chips
                            outlined
                        />-->
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <categories-options></categories-options>
            </v-tab-item>

        </v-tabs-items>


        <!------------------------------------------------
            Snackbar
        ------------------------------------------------->
        <snackbar ref="snackbar"></snackbar>

    </div>

</template>


<script>
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import draggable from 'vuedraggable'
import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinConfig from '@/mixins/database/MixinConfig'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { useGroupsStore } from '@/stores/GroupsStore'
import { mapState, mapWritableState } from 'pinia'
import CategoriesOptions from '@/components/tabs/categories/CategoriesOptions'
import ProfileApplicationTab from '@/components/profiles/ProfileApplicationTab.vue'
import { useProfilesApplicationStore } from '@/stores/ProfilesApplicationStore'
import MixinListing from '@/mixins/listing/MixinListing'
import { findIndex, lastIndexOf } from 'lodash'
import { usePhonesStore } from '@/stores/PhonesStore'

Vue.use(VueSweetalert2)

export default {
    name: 'CategoriesTab',
    components: {
        ProfileApplicationTab,
        draggable,
        Snackbar,
        CategoriesOptions
    },
    watch: {
        profiles: {
            handler() {
                let self = this
                self.getGroupsFromCategories()
            },
            deep: true,
        },
        currentSelectedConfiguration(newVal) {
            this.currentSelectedConfigurationIndex = this.configurations.findIndex(config => config.key === newVal);
        },
        currentSelectedProfileIndex(newVal) {
            if (newVal > -1 && this.profiles[newVal]) {
                this.currentSelectedProfile = {
                    profileName: this.profiles[newVal].profile_name,
                    profileDescription: this.profiles[newVal].profile_description,
                }
            }
        },
    },
    mixins: [MixinDialog, MixinIcon, MixinConfig, MixinSwalConfirmation, MixinStringManipulation, MixinListing],
    data() {
        return {
            showToggleCategories: true,
            categoriesTab: 0,
            categoriesAutocomplete: '',
            isShowSearch: false,
            categoryGroups: [],
            allCategoryItems: [],
            configurationFilterValue: '',
        }
    },
    computed: {
        ...mapWritableState(useCategoriesStore, {
            profiles: 'profiles',
            whitelist: 'whitelist',
            blacklist: 'blacklist',
            currentSelectedProfile: 'currentSelectedProfile',
            allCategoriesForCurrentSelectedProfile: 'allCategoriesForCurrentSelectedProfile',
        }),
        ...mapState(useGroupsStore, ['groups']),

        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfiguration: 'currentSelectedConfiguration',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
        }),

        hasConfigurations() {
            return this.configurations.length > 0
        },

        /**
         * Derives the matching CategoriesStore profile index from the shared
         * currentSelectedConfiguration via mdmDeviceId bridge.
         *
         * Fallback: if no match by mdmDeviceId, tries matching by configuration key to profile_name.
         */
        currentSelectedProfileIndex() {
            if (!this.currentSelectedConfiguration || !this.configurations || !this.profiles || this.profiles.length === 0) {
                return -1;
            }

            let config = this.configurations.find(c => c.key === this.currentSelectedConfiguration);
            if (!config) {
                return -1;
            }

            // Primary bridge: match via mdmDeviceId
            let mdmDeviceId = config.value?.userInfo?.mdmDeviceId;
            if (mdmDeviceId) {
                let index = findIndex(this.profiles, profile => profile.mdmDeviceId === mdmDeviceId);
                if (index > -1) {
                    return index;
                }
            }

            // Fallback: match configuration key to profile_name
            let fallbackIndex = findIndex(this.profiles, profile => profile.profile_name === this.currentSelectedConfiguration);
            if (fallbackIndex > -1) {
                return fallbackIndex;
            }

            console.warn('CategoriesTab: No matching profile found for configuration', this.currentSelectedConfiguration, 'mdmDeviceId:', mdmDeviceId,
                'Available profiles:', this.profiles.map(p => ({ name: p.profile_name, mdmDeviceId: p.mdmDeviceId, profile_id: p.profile_id })));
            return -1;
        },

        currentSelectedRule() {
            if (!this.profiles || this.profiles.length === 0 || this.currentSelectedProfileIndex === -1) {
                return null;
            }

            return this.profiles[this.currentSelectedProfileIndex];
        },

        // SF-style computed property for group autocomplete
        allGroupsForAutocomplete() {
            const result = [];

            if (!this.groups || !Array.isArray(this.groups)) {
                return result;
            }

            // Process each group
            this.groups.forEach(group => {
                // Add top-level group or folder
                // If it has children, it's a folder
                const isFolder = group.hasOwnProperty('child') && Array.isArray(group.child) && group.child.length > 0;
                result.push({
                    group: group.key,
                    isFolder: isFolder
                });

                // Add child groups if present
                if (isFolder) {
                    group.child.forEach(childGroup => {
                        // Child group might also be a folder with its own children
                        const childIsFolder = childGroup.hasOwnProperty('child') && Array.isArray(childGroup.child) && childGroup.child.length > 0;
                        result.push({
                            parent: group.key,
                            group: childGroup.key,
                            isFolder: childIsFolder
                        });
                    });
                }
            });

            return result;
        }
    },
    methods: {

        markAll(groupName) {

            let self = this

            if (self.currentSelectedProfileIndex === -1) return

            let currentProfile = [self.profiles[self.currentSelectedProfileIndex]]

            if (currentProfile?.length === 1) {

                let color = self.getGroupLevelColor(groupName)

                if (['grey', 'orange', 'green'].includes(color)) {

                    let status

                    if (['grey', 'orange'].includes(color)) {
                        status = 1
                    } else if (color === 'green') {
                        status = 0
                    }

                    let hasLockedItem = ''

                    currentProfile[0].categories.map(category => {

                        if (category.group === groupName && category.status !== -1) {
                            category.status = status
                        } else if (category.group === groupName) {
                            hasLockedItem += category.name + ', '
                        }

                        return category
                    })

                    if (hasLockedItem.length > 0) {
                        self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! access for some item(s) cannot be changed. This is for your safety.'), 'error')
                    }

                }

            }

        },

        updateToggleCategoriesValue(val) {
            this.showToggleCategories = val
        },

        selectConfiguration(configurationName) {
            if (configurationName) {
                this.currentSelectedConfiguration = configurationName;
                this.$nextTick(() => {
                    this.currentSelectedConfiguration = configurationName;
                });
            }
        },

        checkEachConfiguration(configurationName) {
            let configurationVisibility = true;
            if (this.configurationFilterValue && this.configurationFilterValue.length > 0) {
                configurationVisibility = configurationName &&
                    configurationName.toLowerCase().includes(this.configurationFilterValue.toLowerCase());
            }
            return configurationVisibility;
        },

        currentViewConfigurationCount() {
            let count = 0
            if (this.configurations && Object.keys(this.configurations).length > 0) {
                for (let key in this.configurations) {
                    if (this.checkEachConfiguration(this.configurations[key].key)) {
                        count++
                    }
                }
            }
            return count
        },

        configurationSelectedForMobile() {
            return (
                this.$vuetify.breakpoint.smAndUp ||
                (this.$vuetify.breakpoint.mobile && !this.currentSelectedConfiguration)
            );
        },

        getGroupsFromCategories() {

            let self = this

            self.profiles?.forEach((profile) => {

                profile.categories.forEach(category => {

                    let itemToPush = {
                        groupName: category.group,
                        profile: profile.profile_name
                    }

                    if (!self.categoryGroups.some(group => (group.groupName === itemToPush.groupName && group.profile === itemToPush.profile))) {
                        self.categoryGroups.push(itemToPush)
                    }

                })

            })

        },

        setAllCategoryItems() {

            let self = this
            let categoryItems = []

            self.profiles?.forEach((profile) => {

                profile.categories.forEach((categoryItem) => {
                    categoryItems.push({
                        name: categoryItem.name,
                        status: categoryItem.status,
                        group: categoryItem.group,
                        profileName: profile.profileName,
                    })
                })

            })

            self.allCategoryItems = categoryItems

        },

        toggleCategoryItemStatus(categoryItem) {

            let self = this
            const translatedCatName = self.$gettext(categoryItem.name)
            const catNameObj = { categoryName: translatedCatName }

            function blurAutocomplete() {

                setTimeout(function () {
                    self.$nextTick(() => {
                        self.categoriesAutocomplete = ''
                        if (self.$refs.categoriesAutocompleteRef) {
                            self.$refs.categoriesAutocompleteRef.blur()
                        }
                    })
                }, 100)

            }

            if (categoryItem.status === -1) {

                self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Sorry, access for %{categoryName} cannot be changed. This is for your safety.'), catNameObj), 'error')

                blurAutocomplete()

            } else {

                if (categoryItem.status === 1) {

                    categoryItem.status = 0
                    self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Successfully disabled access for %{ categoryName }'), catNameObj))

                } else {

                    categoryItem.status = 1
                    self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Successfully enabled access for %{ categoryName }'), catNameObj))

                }

                blurAutocomplete()

            }

        },

        showSearch() {
            let self = this
            self.isShowSearch = true
            setTimeout(function () {
                if (self.$refs.categoriesAutocompleteRef) {
                    self.$refs.categoriesAutocompleteRef.focus()
                }
            }, 100)
        },

        getGroupLevelColor(group) {

            let self = this
            let categoryItems = []

            let color = 'grey'

            if (self.currentSelectedProfileIndex > -1) {
                let currentProfile = self.profiles[self.currentSelectedProfileIndex]
                categoryItems = currentProfile.categories.filter(category => {
                    return (category.group === group)
                })
            }

            if (categoryItems.length > 0) {

                for (let subCategory of categoryItems) {

                    if (subCategory.status === 1) {
                        color = 'green'
                    }
                }

                if (color === 'green') {
                    for (let subCategory of categoryItems) {
                        if (subCategory.status === 0 || subCategory.status === -1) {
                            color = 'orange'
                        }
                    }
                }
            }

            return color

        },

        openEditGroupsDialog() {

            let homeComponent = this.genericComponentGetComponent('Home');
            if (homeComponent) {
                homeComponent.currentTab = 'groups';
            }

        },

        removeDestGroup(group) {
            // Simple method to remove a group from the selection
            let self = this;

            if (!self.currentSelectedRule || !self.currentSelectedRule.next_allowed_groups) {
                return;
            }

            const groupToRemove = group.parent ? `${group.parent}/${group.group}` : group.group;
            const index = self.currentSelectedRule.next_allowed_groups.indexOf(groupToRemove);

            if (index !== -1) {
                self.currentSelectedRule.next_allowed_groups.splice(index, 1);
            }
        },

        getDomainsForGroup(groupName, folderName = null) {
            // Find domains associated with a group
            const self = this;
            const groupPath = folderName ? `${folderName}/${groupName}` : groupName;

            // Find the group in the groups array
            for (const group of self.groups || []) {
                // Check if this is the group we're looking for
                if (!folderName && group.key === groupName) {
                    return group.value?.dest_domains || [];
                }

                // Check child groups if this is a folder
                if (folderName && group.key === folderName && group.child) {
                    for (const childGroup of group.child) {
                        if (childGroup.key === groupName) {
                            return childGroup.value?.dest_domains || [];
                        }
                    }
                }
            }

            return [];
        },

        addNewGroup() {
            // Navigate to the Groups tab to add a new group
            let homeComponent = this.genericComponentGetComponent('Home');
            if (homeComponent) {
                homeComponent.currentTab = 'groups';

                // Optionally, we could add logic to open the "New Group" dialog directly
                // if the Groups component has such a method
                setTimeout(() => {
                    if (homeComponent.$refs.groupsTabRef) {
                        const groupsTab = homeComponent.$refs.groupsTabRef;
                        // Check if the GroupsTab component has an addGroup method
                        if (typeof groupsTab.addGroup === 'function') {
                            groupsTab.addGroup();
                        }
                    }
                }, 100);
            }
        },

        sortGroups() {
            // Sort groups in the allGroupsForAutocomplete array
            let self = this;

            if (!self.allGroupsForAutocomplete || !Array.isArray(self.allGroupsForAutocomplete)) {
                return;
            }

            // Sort by:
            // 1. Parent folders first (empty parent means it's a top-level group)
            // 2. Alphabetical order of parent folders
            // 3. Alphabetical order of groups within the same folder
            self.allGroupsForAutocomplete.sort((a, b) => {
                // If one has a parent and the other doesn't, the one with parent comes first
                if (a.parent && !b.parent) return -1;
                if (!a.parent && b.parent) return 1;

                // If both have parents, compare parent names
                if (a.parent && b.parent) {
                    const parentCompare = a.parent.localeCompare(b.parent, undefined, { sensitivity: 'base' });

                    // If same parent, compare group names
                    if (parentCompare === 0) {
                        return a.group.localeCompare(b.group, undefined, { sensitivity: 'base' });
                    }

                    return parentCompare;
                }

                // If neither has parents, compare group names
                return a.group.localeCompare(b.group, undefined, { sensitivity: 'base' });
            });
        },

        sortSelectedGroups() {
            // Sort the selected groups in the currentSelectedRule
            let self = this;

            if (!self.currentSelectedRule || !self.currentSelectedRule.next_allowed_groups) {
                return;
            }

            // Sort by:
            // 1. Folder groups first (containing a slash)
            // 2. Alphabetical order of folder names
            // 3. Alphabetical order of groups
            self.currentSelectedRule.next_allowed_groups.sort((a, b) => {
                const aHasSlash = a.indexOf('/') !== -1;
                const bHasSlash = b.indexOf('/') !== -1;

                // If one has a slash and the other doesn't, the one with slash comes first
                if (aHasSlash && !bHasSlash) return -1;
                if (!aHasSlash && bHasSlash) return 1;

                // If both have slashes, compare folder names first
                if (aHasSlash && bHasSlash) {
                    const aFolder = a.split('/')[0];
                    const bFolder = b.split('/')[0];
                    const folderCompare = aFolder.localeCompare(bFolder, undefined, { sensitivity: 'base' });

                    // If same folder, compare group names
                    if (folderCompare === 0) {
                        const aGroup = a.split('/')[1];
                        const bGroup = b.split('/')[1];
                        return aGroup.localeCompare(bGroup, undefined, { sensitivity: 'base' });
                    }

                    return folderCompare;
                }

                // If neither has slashes, compare the names directly
                return a.localeCompare(b, undefined, { sensitivity: 'base' });
            });
        },

        getDeviceName(mdmDeviceId, profileName) {

            const config = this.configurations.find(c => c.value.userInfo.mdmDeviceId === mdmDeviceId);

            if (!config) {
                console.error('No config found for mdmDeviceId', mdmDeviceId)
                return profileName
            }

            return config.key || profileName

        }

    },

    mounted() {

        let self = this

        self.setAllCategoryItems()
        // onload for the first time. Otherwise, groups won't be filled in and nothing will populate in the frontend...
        self.getGroupsFromCategories()

        // If we have configurations but none selected, select the first one
        if (self.hasConfigurations && !self.currentSelectedConfiguration) {
            let firstConfig = self.configurations[0];
            if (firstConfig) {
                self.selectConfiguration(firstConfig.key);
            }
        }

    },
}
</script>

<style type="text/scss">
/*------------------------------------------------
    Remove unused from below
--------------------------------------------------*/

.v-expansion-panel-header {
    padding-top: 8px;
    padding-bottom: 8px;
}

.chosen-user-delete-icon .v-list-item__icon {
    margin: 10px 0;
}

/*.rule-active-checkbox-wrapper {
    .v-input {
        margin-top: 0 !important;
    }
}*/

.v-expansion-panel-content__wrap {
    /* default padding: 0 24px 16px;*/
    padding: 5px 12px;
}


.user-listing .v-list-item,
.chosen-user-delete-icon .v-list-item {
    min-height: 42px;
}

.rule-checkbox .v-icon.v-icon {
    font-size: 20px;
}

.add-border-list-on-small-devices {
    border-bottom: 2px solid #eeeeeea6;
    padding-top: 5px;
    padding-bottom: 5px;
}

.v-list-wrapper {
    overflow-y: auto;
}

.internet-filter-user-icon .v-list-item__icon {
    align-self: center;
}

.internet-filter-expansion .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 40px;
}

.internet-filter-list-item .v-list-item {
    min-height: 35px;
}

.internet-filter-content-header-block {
    background-color: #d4dbde !important;
    border-color: #607d8b !important;
}

/*.search-rule-autocomplete {
    position: -webkit-sticky;
    position: sticky;
    top: 250px;
    z-index: 2;
}*/
</style>
